module.exports = __webpack_public_path__ + "static/img/icon1.1cdf85d6.svg";